import { produce } from 'immer';
import { uuid } from '../../utils/utils';
import { ADD_ACTION_ERROR_CHAT_ITEM, ADD_ACTION_RESULT_CHAT_ITEM, ADD_HAND_REVEAL_CHAT_ITEM, ADD_HTML_CHAT_ITEM, ADD_PLAYER_ENTER_CHAT_ITEM, ADD_PLAYER_LEAVE_CHAT_ITEM, ADD_PLAYER_MESSAGE_CHAT_ITEM_FROM_INBOUND, CLEAR_CHAT_ITEMS, SET_BLOCKED_CHAT_PLAYERS_FROM_INBOUND } from '../actions/chatActions';
const initialState = {
    nextItemId: 0,
    orderedItemIds: [],
    itemsById: {},
    blockedChatPlayerIds: []
};
function isLimitingChatItemsForTesting() {
    const params = new URLSearchParams(window.location.search);
    return params.has('limitChatItems');
}
const MAX_NUM_ITEMS = isLimitingChatItemsForTesting() ? 5 : 200;
const MAX_ITEM_ID = isLimitingChatItemsForTesting() ? 5 : 1000000;
function pruneItemsBeforeAdd(draft) {
    // because we are about to add an item, prune down to one less than the max:
    while (draft.orderedItemIds.length > MAX_NUM_ITEMS - 1) {
        // remove oldest chat item from both collections:
        const itemId = draft.orderedItemIds[0];
        draft.orderedItemIds.splice(0, 1);
        delete draft.itemsById[itemId];
    }
}
function addItem(draft, newItemWithoutId) {
    if ('html' in newItemWithoutId && !newItemWithoutId.html) {
        // nothing to display, ignore
        return;
    }
    pruneItemsBeforeAdd(draft);
    const itemId = `chat-${draft.nextItemId}`;
    const newItem = { ...newItemWithoutId, itemId };
    draft.orderedItemIds.push(itemId);
    draft.itemsById[itemId] = newItem;
    draft.nextItemId = (draft.nextItemId + 1) % MAX_ITEM_ID;
}
const chatReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_CHAT_ITEMS: {
                draft.orderedItemIds = [];
                draft.itemsById = {};
                break;
            }
            case ADD_PLAYER_MESSAGE_CHAT_ITEM_FROM_INBOUND: {
                if (draft.blockedChatPlayerIds.includes(action.payload.playerId)) {
                    // chat from this player is blocked, ignore it
                    break;
                }
                addItem(draft, { type: 'chat', html: action.payload.html });
                break;
            }
            case ADD_HTML_CHAT_ITEM: {
                // TODO: Should this be a different 'type' with potentially different render styling?
                addItem(draft, { type: 'chat', html: action.payload });
                break;
            }
            case ADD_ACTION_RESULT_CHAT_ITEM: {
                addItem(draft, { type: 'result', html: action.payload });
                break;
            }
            case ADD_ACTION_ERROR_CHAT_ITEM: {
                addItem(draft, { type: 'error', html: action.payload });
                break;
            }
            case ADD_PLAYER_ENTER_CHAT_ITEM: {
                addItem(draft, { type: 'player-enter', html: action.payload });
                break;
            }
            case ADD_PLAYER_LEAVE_CHAT_ITEM: {
                addItem(draft, { type: 'player-leave', html: action.payload });
                break;
            }
            case ADD_HAND_REVEAL_CHAT_ITEM: {
                const { username, handName, cards, communityCards, rabbits } = action.payload;
                addItem(draft, {
                    type: 'hand-reveal',
                    uuid: uuid(), // uuid is a little hack here to give confidence that using a redux selector with shallowEqual is sufficient to not allow false positives
                    username,
                    handName,
                    cards,
                    communityCards,
                    rabbits
                });
                break;
            }
            case SET_BLOCKED_CHAT_PLAYERS_FROM_INBOUND: {
                draft.blockedChatPlayerIds = action.payload.playerIds;
                break;
            }
            default: {
                return state;
            }
        }
    });
};
export default chatReducer;
